import {useTanqueMap} from "saneamiento/tanque/hooks";
import {FormMapGeojsonPoint} from "base/component/form";
import {useOutletContext} from "react-router-dom";

const TanqueFormLocationFields = ({isCreationForm = false}) => {
    let concello;
    [concello] = useOutletContext();

    const {mapConfig} = useTanqueMap(isCreationForm ? concello : null);

    return (
        <FormMapGeojsonPoint
            name="geom"
            mapConfig={mapConfig}
            rules={{required: "O campo é obrigatorio"}}
        />
    );
};

export default TanqueFormLocationFields;
